import "../../styles/main.less";

import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { Header } from "../Header/Header";
import { Content } from "../Content/Content";
import { ContactUsModal } from "../Modals/ContactUsModal/ContactUsModal";
import TermsAndConditionsModal from "../Modals/TermsAndConditionsModal/TermsAndConditionsModal";
import { NoExistingAccountModal } from "../Modals/NoExistingAccountModal/NoExistingAccountModal";
import { SelectInstitutionModal } from "../Modals/SelectInstitutionModal/SelectInstitutionModal";

import queryString from "query-string";

class Layout extends Component {
	render() {
		const query = queryString.parse(this.props.location.search);

		return (
			<div>
				<Header />
				<Content children={this.props.children} noContentWrapper={this.props.noContentWrapper}/>
				<ContactUsModal />
				<TermsAndConditionsModal noInputs={true} />
				<SelectInstitutionModal show={this.isSelectInstitutionModalVisible(query)} />
				<NoExistingAccountModal show={this.isNoExistingAccountModalVisible(query)} />
			</div>
		);
	}

	isSelectInstitutionModalVisible(queryString) {
		return queryString.bothaccess !== undefined;
	}

	isNoExistingAccountModalVisible(queryString) {
		return queryString.unknownaccount !== undefined;
	}
}

const LayoutWithRouter = withRouter(Layout);
export { LayoutWithRouter as Layout };


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js